import { render, staticRenderFns } from "./PrestacionesView.vue?vue&type=template&id=6ff83b7a&"
import script from "./PrestacionesView.vue?vue&type=script&lang=js&"
export * from "./PrestacionesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports